import React from 'react'
import { Button, Breadcrumb, Accordion, Icon } from 'semantic-ui-react'
import MatchesList from './MatchesList'
import { connect } from 'react-redux'
import { selectMatches } from '../reducers/matches'
import { editMatch, stopEditMatch } from '../reducers/editMatchId'
import EditMatchForm from './EditMatchForm'


class MatchesSections extends React.Component {
    state = { openPanels: [false, true, false] }

    handleToggle = (e, { index }) => {
        const newPanels = this.state.openPanels.slice()
        newPanels[index] = !newPanels[index]
        this.setState({ openPanels: newPanels })
    }

    render() {
        const { matches, socket } = this.props
        const [ runningOpen, availableOpen, completedOpen ] = this.state.openPanels
        const runningMatches = matches.filter(m => m.starting_time && !m.ending_time)
        const availableMatches = matches.filter(m => !m.starting_time && !m.ending_time)
        const completedMatches = matches.filter(m => m.ending_time)

        return (
            <Accordion>
                <Accordion.Title active={runningOpen || runningMatches.length !== 0} index={0} onClick={this.handleToggle}>
                    <Icon name='dropdown' />
                    In onda ({runningMatches.length})
                </Accordion.Title>
                <Accordion.Content active={runningOpen || runningMatches.length !== 0}><MatchesList matches={runningMatches} socket={socket} /></Accordion.Content>
                <Accordion.Title active={availableOpen} index={1} onClick={this.handleToggle}>
                    <Icon name='dropdown' />
                    Future ({availableMatches.length})
                </Accordion.Title>
                <Accordion.Content active={availableOpen}><MatchesList matches={availableMatches} socket={socket} /></Accordion.Content>

                <Accordion.Title active={completedOpen} index={2} onClick={this.handleToggle}>
                    <Icon name='dropdown' />
                    Completate ({completedMatches.length})
                </Accordion.Title>
                <Accordion.Content active={completedOpen}><MatchesList matches={completedMatches} socket={socket} /></Accordion.Content>

            </Accordion>
        )
    }
}


const MatchesPage = ({ matches, editMatchId, socket, onNewClick, onStopEditMatchClick }) => {
    const isMatchSelected = !!editMatchId
    
    return (
        <div>
            <Breadcrumb size='massive' style={{marginTop: '1em', marginBottom: '1em'}}>
                <Breadcrumb.Section link={isMatchSelected} active={!isMatchSelected} onClick={isMatchSelected ? onStopEditMatchClick : null}>Puntate</Breadcrumb.Section>
                {isMatchSelected ? <Breadcrumb.Divider icon='right angle'/> : null}
                {isMatchSelected ? <Breadcrumb.Section active>Puntata</Breadcrumb.Section> : null}
            </Breadcrumb>
            {isMatchSelected ? (
                <div>
                    <EditMatchForm socket={socket} game_id={editMatchId} />
                </div>
            ) : (
                <div>
                    <div>
                        <Button primary onClick={onNewClick}>Crea puntata</Button>
                    </div>
                    <MatchesSections matches={matches} socket={socket} />
                </div>
            )}
        </div>
    )
}


const mapStateToProps = (state, { socket }) => ({
    socket,
    matches: selectMatches(state),
    editMatchId: state.editMatchId,
    question_game: state.question_game,
})

const mapDispatchToProps = (dispatch, { socket }) => ({
    onNewClick: () => dispatch(editMatch('new')),
    onStopEditMatchClick: () => dispatch(stopEditMatch()),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MatchesPage)


// WEBPACK FOOTER //
// ./src/components/MatchesPage.js